let scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;
    setTimeout(function () {
      loadScript("//www.aiza.co/cdn/shop/t/152/assets/document-click-scripts.js?v=162944289668529104691786962251");
      loadScript("//www.aiza.co/cdn/shop/t/152/assets/cart-redirection.js?v=56065149766165652271783250338");
      loadScript("//www.aiza.co/cdn/shop/t/152/assets/ga-events.js?v=112035484872703753811783250336");
      loadCSS("//www.aiza.co/cdn/shop/t/152/assets/bt-common.css?v=65345948001286532301786962243");
    }, 10);


  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

if (window.scrollY >= 400) {
  loadScripts();
} else {
  document.addEventListener('mouseover', loadScripts);
  document.addEventListener('click', loadScripts);
  document.addEventListener('scroll', loadScripts, { passive: true });
}

function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}